/**
 * Tuneables for the manual / adhoc scheduling calendar.
 *
 * Everything here is display / behavioural config — no logic.
 * Tweak a value, reload, see the effect. If you want to change a
 * color or animation, do it here first rather than hard-coding inside
 * the hooks or CSS.
 *
 * Paired with `calendar.css` which consumes the CSS variables below
 * via `var(--kula-colors-...)`. The JS constants are used by the
 * hooks when they emit FullCalendar event inputs.
 */

/** Default minimum bookable slot size (minutes). Gap-finder drops
 *  gaps shorter than this. Also used as the snap grid on the calendar. */
export const DEFAULT_MIN_SLOT_MINUTES = 15;

/** Calendar fetch windowing — applies to both calendar events and
 *  the new interviewer-schedule prefetch. `prefetchWeeks` run eagerly,
 *  `lookaheadPrefetchWeeks` run in the background.
 *
 *  Total window = visible week + 1 silent prefetch (next week). Going
 *  wider eagerly multiplied the visible-week trigger_fetch storm by
 *  the same factor (sch-31 #4); next-next navigation is rare enough
 *  to pay one fetch on the click. */
export const CALENDAR_PREFETCH_WEEKS = 2;
export const CALENDAR_LOOKAHEAD_WEEKS = 1;

/** How far into the past to shade the "can't book" background. */
export const PAST_BACKGROUND_YEARS = 10;

/** Pulse animation duration for the animated "Available" overlay (ms). */
export const AVAILABLE_SLOT_PULSE_MS = 3000;

/** Category strings (also used as `extendedProps.category` — keep in sync
 *  with CSS selectors in `calendar.css`). */
export const EVENT_CATEGORIES = {
  booked: 'booked',
  busy: 'busy',
  available: 'available',
  unavailableHours: 'unavailable-hours',
  minimumNotice: 'minimum-notice',
  pastTime: 'past-time',
} as const;

/** CSS class names used on `classNames` for events. Match `calendar.css`. */
export const EVENT_CLASS_NAMES = {
  available: 'im-available-slot',
  busy: 'im-interviewer-busy',
  booked: 'booked-event',
  unavailableHours: 'bg-unavailable-working-hours',
  minimumNotice: 'bg-minimum-notice-disabled-slots',
  pastTime: 'bg-disabled-slots',
} as const;
